import { useTranslation } from 'react-i18next'
import { useHydrated } from '@/hooks/use-hydrated'

/**
 * `t`, but English until the page has hydrated.
 *
 * The language is detected in the browser, so the server always renders the
 * fallback. Reading the detected language while hydrating would therefore
 * disagree with the server HTML, and React throws the whole root back to client
 * rendering over it.
 */
export function useSafeTranslation() {
  const { t, i18n } = useTranslation()

  return useHydrated() ? t : i18n.getFixedT('en')
}

/** The writing direction, but `ltr` until the page has hydrated. */
export function useSafeDirection(): 'ltr' | 'rtl' {
  const { i18n } = useTranslation()

  return useHydrated() ? (i18n.dir() as 'ltr' | 'rtl') : 'ltr'
}
